import { AntenaGrupoFormType } from './AntenaGrupoFormType';
import { YupShape } from 'shared/models/YupShape';
import * as Yup from 'yup';

export const antenagrupoFormValidation: YupShape<AntenaGrupoFormType> =
  Yup.object().shape({
    nombre: Yup.string().required('El nombre es requerido')
  });
